import { css } from 'styled-components';

export const styleNormaliseTweaks = css`
  h1, h2, h3, h4, h5, h6, p, dl, dd, ul, ol, li, figure {
    margin: 0;
    padding: 0;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: normal;
    font-size: 100%;
  }

  ul {
    list-style: none;
  }

  html {
    box-sizing: border-box;
  }

  *, *::before, *::after {
    box-sizing: inherit;
  }

  ol, ul {
    list-style-position: inside;
  }

  textarea {
    max-width: 100%;
    resize: vertical;
  }

  fieldset {
    border: none;
    margin: 0;
    padding: 0;
  }

  select {
    color: black;
  }

  iframe {
    border: none;
  }

  button {
    border: none;
    background: none;
    box-shadow: none;
    padding: 0;
    cursor: pointer;
    font-size: inherit;
    line-height: inherit;
    text-align: inherit;
    color: inherit;
  }

  a {
    text-decoration: none;
    color: currentColor;
  }

  table {
    border: none;
    width: 100%;
  }

  th {
    text-align: start;
  }

  svg {
    width: auto;
    height: inherit;
  }
`;
